/**
 * 平台差异全部收口在这里：
 *   - role：creator（达人）
 *   - platform：运行时判断 pc / h5
 *   - ModalShell：统一常驻 fixed shell（桌面全屏 / 移动端底部）
 *
 * App.tsx 只需 <TimModal />，对平台细节零感知。
 */
import React from 'react';
import { isMobile } from '@/biz/tool';
import { CloseIcon } from '@/components/common/icon';
import TimModal from './TimModal';
import ModalShell from './ModalShell';

const CreatorTimModal: React.FC = () => (
  <TimModal
    role="creator"
    platform={isMobile() ? 'h5' : 'pc'}
    ModalShell={ModalShell}
    closeIcon={<CloseIcon className="w-[16px] h-[16px]" />}
  />
);

export default CreatorTimModal;
